import { Injectable } from '@angular/core';

import { Cor } from "./cor.model";
import { apiName } from "./data.service";
import { RestService } from "../../core/services/rest.service";

@Injectable()
export class CorApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Cor, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: Cor, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"cor","where":{"ativo":true}};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    this._restService.onGetPostId(apiName, objectId, {}, done);
  }

  onGetApiUrl() {
    return apiName;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/cores/cor-api.service.ts
 **/